/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

import {
  DEFAULT_INSPECTION_MODE,
  POSITION_IMPERIAL,
  POSITION_METRIC,
  POSITION_TIME_OF_FLIGHT,
} from './parameter-infos.constants';

export const tcgParameters: Record<string, ParameterInfos> = {
  Tcg_PointGain: {
    metric: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'dB',
      decimals: 1,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    inspectionMode: DEFAULT_INSPECTION_MODE,
  },
  Tcg_PointPosition: {
    metric: POSITION_METRIC,
    imperial: POSITION_IMPERIAL,
    timeOfFlight: POSITION_TIME_OF_FLIGHT,
    sourceUnit: 'm',
    inspectionMode: DEFAULT_INSPECTION_MODE,
  },
};
